@if(adminUser$ | async; as user) {
<div class="dropdown-center">
  <button class="btn border-0 dropdown-toggle d-inline-flex align-items-center gap-3 p-0" data-bs-toggle="dropdown" title="Kullanıcı Menüsü" type="button" aria-expanded="false" aria-label="Kullanıcı Menüsü" i18n-aria-label i18n-title>
    @if (user.photoURL; as photoUrl) {
    <img alt="Avatar" class="rounded-circle" src="{{ photoUrl }}" style="width: 1.5rem; height: 1.5rem;" aria-hidden="true" i18n-alt />
    } @else {
    <fa-icon [icon]="faUser" [fixedWidth]="true" aria-hidden="true" />
    }

    @if (user.displayName; as displayName) {
    <small>{{ displayName }}</small>
    }
  </button>

  <div class="dropdown-menu shadow-sm" aria-label="Kullanıcı Menüsü" i18n-aria-label>
    <div class="d-flex flex-column align-items-center p-2">
      <div class="my-2" style="height: 4rem; width: 4rem;">
        @if (user.photoURL; as photoUrl) {
        <img alt="Avatar" class="rounded-circle h-100 w-100" src="{{ photoUrl }}" i18n-alt />
        } @else {
        <fa-icon [icon]="faUser" [fixedWidth]="true" aria-hidden="true" />
        }
      </div>

      <h6 class="text-body mb-1">
        <strong>{{ user.displayName }}</strong>
      </h6>
      <small class="text-body-secondary">{{ user.email }}</small>
    </div>
    <hr class="dropdown-divider">
    <button class="dropdown-action btn btn-danger mt-1 py-1 w-100" (click)="onSignOut()" type="button">
      <small i18n>Çıkış Yap</small>
    </button>
  </div>
</div>
}